var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M13.083,3h-5.5a4.583,4.583,0,0,0,0,9.167h5.5a4.583,4.583,0,0,0,0-9.167Zm0,7.333h-5.5a2.75,2.75,0,0,1,0-5.5h5.5a2.75,2.75,0,0,1,0,5.5Zm0,5.5h-5.5A4.583,4.583,0,0,0,3,20.417v11A4.583,4.583,0,0,0,7.583,36h5.5a4.583,4.583,0,0,0,4.583-4.583v-11A4.583,4.583,0,0,0,13.083,15.833Zm2.75,15.583a2.75,2.75,0,0,1-2.75,2.75h-5.5a2.75,2.75,0,0,1-2.75-2.75v-11a2.75,2.75,0,0,1,2.75-2.75h5.5a2.75,2.75,0,0,1,2.75,2.75Zm15.583-4.583h-5.5a4.583,4.583,0,0,0,0,9.167h5.5a4.583,4.583,0,1,0,0-9.167Zm0,7.333h-5.5a2.75,2.75,0,0,1,0-5.5h5.5a2.75,2.75,0,1,1,0,5.5ZM31.417,3h-5.5a4.583,4.583,0,0,0-4.583,4.583v11a4.583,4.583,0,0,0,4.583,4.583h5.5A4.583,4.583,0,0,0,36,18.583v-11A4.583,4.583,0,0,0,31.417,3Zm2.75,15.583a2.75,2.75,0,0,1-2.75,2.75h-5.5a2.75,2.75,0,0,1-2.75-2.75v-11a2.75,2.75,0,0,1,2.75-2.75h5.5a2.75,2.75,0,0,1,2.75,2.75Z",
    transform: "translate(-3 -3)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.6a7191ec62d57b6616220703872243bb.svg";
export { ForwardRef as ReactComponent };